const state = {
  catTree: null, //目录整体数据
  level: 1, //当前选择的层级, 1:分类, 2:部位, 3:配件
  l3Tab: 1, //L3顶部菜单, 1:基础信息, 2:OE信息
  l2Filter: false, //是否过滤已选的L2部位配件数据
  cL1: { //当前选择的分类
    id: -1,
    index: -1,
    isNew: false
  },
  cL2: { //当前选择的部位
    id: -1,
    index: -1,
    isNew: false
  },
  cL3: { //当前选择的配件
    l3Id: -1,
    l3Index: -1,
    l2Id: -1,
    l2Index: -1,
    isNew: false
  },
  l1FormData: null, //L1表单内容, 用于编辑提交
  l2FormData: null, //L2表单内容, 用于编辑提交
  l3FormData: null, //L3表单内容, 用于编辑提交
  l4FormData: null, //L4表单内容, 用于编辑提交
  modelInfo: null, //L4已选车型,9019, null
  vin: "LFV3B28RXB3053661", //有范例数据的VIN:LFV3B28RXB3053661
  modelFrom: 0, //车型锁定来源，0=车架号，1=车型选择

  partSelectType: 2, // 1单选 2多选
  partSelectList: [], //已选配件数据 
}

const mutations = {
  //同步设置
  CHANGE_SEPC: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  }
}

const actions = {
  //异步设置
  changeSEPC({ commit }, data) {
    commit('CHANGE_SEPC', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/sepc.js